<template>
  <div>
    <mtd-row class="page-title-block">
      <mtd-col :span="21" class="height-full">
        <mtd-icon-button class="demo-icon-btn" type="secondary" icon="mtdicon mtdicon-arrow-left" @click="back_alarms"/>
        <span class="page-head-title" style="margin-left: 12px;">告警通知</span>
      </mtd-col>
      <a href="https://km.sankuai.com/collabpage/2257670643" target="_blank">
        <mtd-button :span="3" type="text" icon="mtdicon mtdicon-question-circle-o" style="float: right">
          <span>告警处理FAQ</span>
        </mtd-button>
      </a>
    </mtd-row>
    <div class="page-content-block">
      <mtd-row>
        <mtd-col :span="24" class="height-full">
          <mtd-announcement
            title="公告信息"
            type="info"
            show-icon>
            <span>请关注告警内容，我们将持续保障您的数据安全。</span>
          </mtd-announcement>
        </mtd-col>
      </mtd-row>
      <mtd-row>
        <mtd-col :span="24" class="height-full">
          <table class="full-block-table" style="margin-top: 16px;">
            <tr class="table-row">
              <td class="td-title">当事人账号</td>
              <td>{{alarm_info.beAlertedMis}}</td>
            </tr>
            <tr class="table-row">
              <td class="td-title">风险等级</td>
              <td>
                <mtd-tag theme="red" type="pure" size="small" v-if="alarm_info.riskLevel === 'P0'">紧急</mtd-tag>
                <mtd-tag theme="orange" type="pure" size="small" v-if="alarm_info.riskLevel === 'P1'">高</mtd-tag>
                <mtd-tag theme="purple" style="background-color: #EFC46F;border-color: #EFC46F" type="pure" size="small" v-if="alarm_info.riskLevel === 'P2'">中</mtd-tag>
                <mtd-tag theme="blue" type="pure" size="small" v-if="alarm_info.riskLevel === 'P3'">低</mtd-tag>
              </td>
            </tr>
            <tr class="table-row">
              <td class="td-title">风险详情</td>
              <td class="alarm_info_content"><span v-html="alarm_info.supervisor === login_user.mis_id ? alarm_info.superiorContent : alarm_info.content"></span></td>
            </tr>
          </table>
        </mtd-col>
      </mtd-row>
      <!-- 用户反馈信息 -->
      <mtd-row style="margin-top: 34px;" v-if="!file_out_show">
        <mtd-col :span="24" class="height-full">
          <span class="page-second-title">{{appeal_user}}的反馈信息</span>
          <mtd-tag theme="red" type="pure" class="page-head-title-tag" v-if="alarm_info.visitFlag === 0">未查看</mtd-tag>
          <mtd-tag theme="green" type="pure" class="page-head-title-tag" v-if="alarm_info.visitFlag === 1">已查看</mtd-tag>
        </mtd-col>
        <mtd-col :span="24" class="height-full">
          <table class="full-block-table" style="margin-top: 16px;margin-bottom: 9px;">
            <tr class="table-row">
              <td class="td-title">原因</td>
              <td>{{alarm_info.appealType | appealTypeFilter(this.radioList)}}{{alarm_info.appealReason}}</td>
            </tr>
          </table>
        </mtd-col>
      </mtd-row>
      <!-- 外发问询场景用户反馈信息 -->
      <mtd-row v-if="file_out_show" style="margin-top: 34px;">
        <mtd-col :span="24" class="height-full">
          <span class="page-second-title">{{appeal_user}}的反馈信息</span>
        </mtd-col>
        <mtd-col :span="24" class="height-full">
          <table class="full-block-table" style="margin-top: 16px;margin-bottom: 9px;">
            <tr class="table-row">
              <td class="td-title">原因</td>
              <td>{{alarm_info.appealType | appealTypeFilter(this.radioList)}}{{alarm_info.appealReason}}</td>
            </tr>
            <tr class="table-row">
              <td class="td-title">发送对象</td>
              <td>{{ alarm_info.sendObject || '暂无' }}</td>
            </tr>
            <tr class="table-row">
              <td class="td-title">发送记录证明</td>
              <td>
                <div style="margin-top: 16px">
                  <img :src="item" v-for="(item, index) in (alarm_info.pictures == null ? [] : alarm_info.pictures.split(','))"
                       v-bind:key="index" style="width: 160px;height: 160px;cursor: pointer" @click="picturePreview(item)"/>
                </div>
                <mtd-modal v-model="resultPreviewModal">
                  <img :src="activeImg"/>
                </mtd-modal>
              </td>
            </tr>
          </table>
        </mtd-col>
      </mtd-row>
      <mtd-row style="margin-top: 34px;" v-if="alarm_info.supervisorFlag === 1">
        <mtd-col :span="24" class="height-full">
          <span class="page-second-title">{{alarm_info.supervisor}}的确认</span>
          <mtd-tag theme="red" type="pure" class="page-head-title-tag" v-if="alarm_info.supervisorVisitFlag === 0">未查看</mtd-tag>
          <mtd-tag theme="green" type="pure" class="page-head-title-tag" v-if="alarm_info.supervisorVisitFlag === 1">已查看</mtd-tag>
        </mtd-col>
        <mtd-col :span="24" class="height-full">
          <table class="full-block-table" style="margin-top: 16px;margin-bottom: 9px;">
            <tr class="table-row">
              <td class="td-title">确认及反馈</td>
              <td>{{feedback_result_show?alarm_info.feedbackReason:alarm_info.supervisorFlag === 1?'暂未填写' : '无需确认'}}</td>
            </tr>
          </table>
        </mtd-col>
      </mtd-row>
    </div>
  </div>
</template>

<script>

  import moment from 'moment';
  import {mapActions} from 'vuex'

  export default {
    name: "detail",
    filters: {
      dateTimeFormat(dateTime) {
        if (dateTime) {
          return moment(dateTime)
            .utcOffset(480)
            .format('YYYY-MM-DD HH:mm:ss');
        } else {
          return "";
        }
      },
      appealTypeFilter(appealType, array) {
        if (!appealType || appealType === '0') {
          return '暂未反馈';
        } else {
          return array.find(item => item === appealType) + '：';
        }
      }
    },
    computed: {
      login_user() {
        return this.$store.getters.get_login_user;
      },
    },
    data() {
      return {
        alarm_id: this.$route.params.id,
        alarm_info: {},
        // 用户反馈
        appeal_show: false,
        appeal_reason: '',
        appeal_other_reason: '',
        // 用户反馈展示
        appeal_user: '',
        appeal_result_show: false,
        file_out_show: false,
        activeImg: '',
        resultPreviewModal: false,
        // 领导确认
        feedback_show: false,
        feedback_reason: '',
        feedback_other_reason: '',
        // 领导确认展示
        feedback_result_show: false,
        radioList: ['工作需要', '不是本人操作', '不清楚原因', '其他'],
      }
    },
    mounted: function () {
      this.init_data();
    },
    methods: {
      ...mapActions([
        'api_query_reminders_inquiries_by_id',
        'api_query_reminders_inquiries_by_id',
        'api_update_reminders_inquiries',
      ]),
      async init_data() {
        let response = await this.api_query_reminders_inquiries_by_id({id: this.alarm_id});
        this.alarm_info = response.data;
        if (this.alarm_info.automaticDispositionId === 14) {
          this.file_out_show = true;
        }
        if (this.alarm_info.rowStatus === 2) {
          this.appeal_show = true;
        }
        if (this.alarm_info.appealReason && this.alarm_info.appealReason !== '') {
          this.appeal_result_show = true;
          this.appeal_user = this.alarm_info.appealUser;
        } else {
          this.appeal_user = this.alarm_info.recipient;
        }
        if (this.alarm_info.rowStatus === 3 || this.alarm_info.supervisorFlag === 1) {
          this.feedback_show = true;
        }
        if (this.alarm_info.feedbackReason && this.alarm_info.feedbackReason !== '') {
          this.feedback_result_show = true;
        }
        if (this.alarm_info.noticeConfig) {
          if (this.alarm_info.noticeConfig.feedbackLabelList) {
            this.radioList = this.alarm_info.noticeConfig.feedbackLabelList.split(',');
          }
          if (this.alarm_info.noticeConfig.supervisorFeedbackLabelList) {
            this.superiorRadioList = this.alarm_info.noticeConfig.supervisorFeedbackLabelList.split(',');
          }
        }
      },
      back_alarms() {
        this.$router.push('/manage');
      },
      picturePreview(item) {
        this.activeImg = item;
        this.resultPreviewModal = true;
      },
    },
  }
</script>

<style>
  .page-head-title {
    font-family: PingFangSC-Medium, sans-serif;
    font-size: 20px;
    color: #333333;
    letter-spacing: 0.5px;
    line-height: 28px;
  }

  .page-head-title-tag {
    font-family: PingFangSC-Regular, sans-serif;
    font-size: 12px;
    line-height: 18px;
    margin-bottom: 6px;
    margin-left: 8px;
  }

  .page-second-title {
    font-family: PingFangSC-Medium, sans-serif;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.87);
    letter-spacing: 0;
    line-height: 22px;
  }

  .padding-left-40 {
    padding-left: 40px;
  }

  .full-block-table {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
    border: 1px solid rgba(0, 0, 0, 0.06);
  }

  .full-block-table .table-row {
    height: 36px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  }

  .full-block-table .table-row td {
    line-height: 36px;
    font-family: PingFangSC-Medium, sans-serif;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.60);
    letter-spacing: 0;
    padding: 0 12px;
    border-right: 1px solid rgba(0, 0, 0, 0.06);
    overflow: hidden;
    /*white-space: nowrap;*/
    /*text-overflow: ellipsis;*/
  }

  .full-block-table .table-row td.td-title {
    background: #F7F7F7;
    width: 130px;
  }

  .feedback-reason-block {
    background: #F7F7F7;
    border: 1px solid rgba(0, 0, 0, 0.07);
    padding: 15px;
    padding-bottom: 0;
  }
  .full-block-table .table-row td.alarm_info_content{
    white-space: normal;
    line-height: 20px;
  }
</style>
